(function(){
  function initHokeeMotionV2(){
    var home=document.querySelector('.hk-home');
    if(!home||home.dataset.hkMotionV2==='ready'){return;}
    home.dataset.hkMotionV2='ready';

    var selector=[
      '.hk-reassurance-injected__item',
      '.hk-low-injected__heading',
      '.hk-low-injected__card',
      '.hk-section--soft .hk-heading',
      '.hk-shopping-card',
      '.hk-products .hk-card',
      '.hk-section--dark',
      '.hk-split > *',
      '.hk-story > *',
      '.hk-newsletter > *'
    ].join(',');

    var targets=Array.prototype.slice.call(home.querySelectorAll(selector));
    home.classList.add('hk-motion-v2');

    targets.forEach(function(el,index){
      el.classList.add('hk-v2-reveal');
      el.style.setProperty('--hk-v2-delay',Math.min(index%4,3)*85+'ms');
    });

    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduced||!('IntersectionObserver' in window)){
      targets.forEach(function(el){el.classList.add('hk-v2-visible');});
      return;
    }

    var observer=new IntersectionObserver(function(entries,obs){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('hk-v2-visible');
          obs.unobserve(entry.target);
        }
      });
    },{threshold:.08,rootMargin:'0px 0px -20px 0px'});

    targets.forEach(function(el){observer.observe(el);});

    requestAnimationFrame(function(){
      targets.forEach(function(el){
        var rect=el.getBoundingClientRect();
        if(rect.top<window.innerHeight*.92&&rect.bottom>0){el.classList.add('hk-v2-visible');observer.unobserve(el);}
      });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initHokeeMotionV2);
  }else{
    initHokeeMotionV2();
  }
  document.addEventListener('shopify:section:load',function(){
    var home=document.querySelector('.hk-home');
    if(home){delete home.dataset.hkMotionV2;initHokeeMotionV2();}
  });
})();
